// extracted by mini-css-extract-plugin
export default {"optionMargin":"CheckerModalFormLight__optionMargin___G4uO2"};